import React from "react";
import "./Home.css";
import {
  Header,
  Footer,
  Seo,
  AdPopup,
  HomeFaq,
  MainBanner,
  HomeEducationPrograms,
  HomeTrustedSystem,
  HomeWhyHopeScience,
  HomeCertificateShowcase,
  HomeSimpleProcess,
  HomeUserReviews,
  HomeEducationOperations,
  HomeCtaBanner,
  HomeContact,
} from "../../components";
import ad02Image from "../../images/ad-02.png";
import { useState, useEffect } from "react";
import {
  SITE_URL,
  SITE_NAME,
  WEBSITE_ID,
  OG_IMAGE,
  ORGANIZATION_NODE,
  ORG_REF,
  canonicalUrl,
} from "../../utils/seo";

const ads = [
  {
    id: 1,
    title: "광고 1",
    imageUrl: ad02Image,
    url: "http://lknike.com/crim1/",
  },
];

export const Home = () => {
  const [visibleAds, setVisibleAds] = useState([]);

  useEffect(() => {
    const filteredAds = ads.filter((ad) => {
      const hideUntil = localStorage.getItem(`hideAd_${ad.id}`);
      return !hideUntil || new Date(hideUntil) < new Date();
    });
    setVisibleAds(filteredAds);
  }, []);

  const closeAd = (adId) => {
    setVisibleAds(visibleAds.filter((ad) => ad.id !== adId));
  };

  const hideAdForWeek = (adId) => {
    const hideUntil = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
    localStorage.setItem(`hideAd_${adId}`, hideUntil.toISOString());
    closeAd(adId);
  };

  return (
    <>
      <Seo
        title="희망과학 심리상담센터 | 온라인 양형교육·재범방지교육"
        description="성범죄·음주운전 등 상황별 온라인 재범방지교육과 양형교육을 안내합니다. 교육 신청부터 수강, 이수증 발급 및 심리상담까지 확인하세요."
        ogTitle="온라인 양형교육·재범방지교육 | 희망과학 심리상담센터"
        ogDescription="상황별 온라인 재범방지교육과 양형교육부터 수강 완료 후 이수증 발급까지 확인하세요."
        image={OG_IMAGE}
        canonical={canonicalUrl("/")}
        jsonLd={{
          "@context": "https://schema.org",
          "@graph": [
            ORGANIZATION_NODE,
            {
              "@type": "WebSite",
              "@id": WEBSITE_ID,
              url: `${SITE_URL}/`,
              name: SITE_NAME,
              publisher: ORG_REF,
              inLanguage: "ko-KR",
            },
            {
              "@type": "WebPage",
              "@id": `${SITE_URL}/#webpage`,
              url: `${SITE_URL}/`,
              name: "희망과학 심리상담센터 | 온라인 양형교육·재범방지교육",
              description:
                "성범죄·음주운전 등 상황별 온라인 재범방지교육과 양형교육을 안내합니다. 교육 신청부터 수강, 이수증 발급 및 심리상담까지 확인하세요.",
              isPartOf: { "@id": WEBSITE_ID },
              about: ORG_REF,
              inLanguage: "ko-KR",
            },
          ],
        }}
      />
      {/* 광고 팝업 비활성화
      {visibleAds.map((ad) => (
        <AdPopup
          key={ad.id}
          ad={ad}
          position={ad.id}
          onClose={() => closeAd(ad.id)}
          onHideForWeek={() => hideAdForWeek(ad.id)}
          url={ad.url}
        />
      ))}
      */}
      <Header variant="light" />
      <MainBanner />
      <HomeEducationPrograms />
      <HomeTrustedSystem />
      <HomeWhyHopeScience />
      <HomeCertificateShowcase />
      <HomeSimpleProcess />
      <HomeUserReviews />
      <HomeFaq />
      <HomeEducationOperations />
      <HomeCtaBanner />
      <HomeContact />
      <Footer variant="light" />
    </>
  );
};
